import { ChangeDetectorRef, Component, OnInit } from '@angular/core'
import { GlobalMessageType, RoutingService } from '@spartacus/core'
import { finalize, switchMap } from 'rxjs/operators'
import { AgreementStatus } from '../../../../../models/enum/agreement.enum'
import { CustomRoutes } from '../../../../../models/enum/custom-routes.enum'
import { SharedErrorType, SharedValue } from '../../../../../models/enum/shared.enum'
import { IAgreement } from '../../../../../models/interface/agreement.interface'
import { ICsv } from '../../../../../models/interface/csv.interface'
import { IHistoryList } from '../../../../../models/interface/history-list.interface'
import { DispenserAgreementService } from '../../../../../services/agreement/dispenser/dispenser-agreement.service'
import { CsvService } from '../../../../../services/shared/csv/csv.service'
import { CustomGlobalMessageService } from '../../../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../../../services/shared/shared.service'
import {
  ICustomTableColumn,
  ICustomTableHeader
} from '../../../../shared/custom-components/custom-table/modals/interface/custom-table.interface'

@Component({
    selector: 'app-dispenser-agreement-detail',
    templateUrl: './dispenser-agreement-detail.component.html',
    styleUrls: ['./dispenser-agreement-detail.component.scss'],
    standalone: false
})
export class DispenserAgreementDetailComponent implements OnInit {
  public agreementCode: string
  public agreement: IAgreement
  public entries: IHistoryList
  public showLoaderOnPagination: boolean
  public showInitialLoader = true
  public showError404: boolean

  public headers: ICustomTableHeader[] = [
    { title: 'dispenserAgreement.materialNumber' },
    { title: 'dispenserAgreement.materialDescription' },
    { title: 'dispenserAgreement.approved' },
    { title: 'dispenserAgreement.dispatched' },
    { title: 'dispenserAgreement.remaining' }
  ]

  public columns: ICustomTableColumn[] = [
    { key: 'product.code' },
    { key: 'product.name' },
    { key: 'quantity' },
    { key: 'issuedDispensers' },
    { key: 'remainingDispensers' }
  ]

  constructor(
    public dispenserAgreementService: DispenserAgreementService,
    public globalMessageService: CustomGlobalMessageService,
    public sharedService: SharedService,
    public csvService: CsvService,
    private changeDetectorRef: ChangeDetectorRef,
    public routingService: RoutingService
  ) {}

  ngOnInit(): void {
    this.sharedService
      .getUrlParam('code')
      .pipe(
        switchMap((code) => {
          this.agreementCode = code
          return this.dispenserAgreementService.getAgreementDetail(code, true)
        }),
        switchMap((detail) => {
          this.agreement = detail
          this.changeDetectorRef.detectChanges()
          return this.dispenserAgreementService.getAgreementDetailEntries(detail?.orderCode)
        }),
        finalize(() => {
          this.showInitialLoader = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe(
        (entries) => {
          this.entries = entries
        },
        (err) => {
          if (err.type === SharedErrorType.notFound404) {
            this.showError404 = true
          }
        }
      )
  }

  public downloadCSV(code: string): void {
    this.dispenserAgreementService.getAgreementDetailAllEntries(code).subscribe(
      (entries) => {
        const csv: ICsv = {
          title: `Dispenser Agreement Detail ${code}`,
          columns: [
            { title: 'dispenserAgreement.materialNumber', key: 'product.code' },
            { title: 'dispenserAgreement.materialDescription', key: 'product.name' },
            { title: 'dispenserAgreement.approved', key: 'quantity' },
            { title: 'dispenserAgreement.dispatched', key: 'issuedDispensers' },
            { title: 'dispenserAgreement.remaining', key: 'remainingDispensers' }
          ],
          rows: entries
        }
        this.csvService.generateCSV(csv)
      },
      (err) => {
        this.globalMessageService.add(err.message, GlobalMessageType.MSG_TYPE_ERROR)
      }
    )
  }

  public shipment(): void {
    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go({
      cxRoute: CustomRoutes.DISPENSER_AGREEMENT_SHIPMENT_HISTORY,
      params: { agreementCode: this.agreementCode }
    })
  }

  public placeOrder(): void {
    // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
    this.routingService.go({
      cxRoute: CustomRoutes.DISPENSER_AGREEMENT_PLACE_ORDER,
      params: { code: this.agreement?.orderCode }
    })
  }

  public pageChange(page: number): void {
    this.showLoaderOnPagination = true
    this.dispenserAgreementService
      .getAgreementDetailEntries(this.agreementCode, { pageNumber: page })
      .pipe(
        finalize(() => {
          this.showLoaderOnPagination = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe(
        (res) => {
          if (!res) {
            this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
          } else {
            this.entries = res
          }
        },
        (err) => {
          if (err.type === SharedErrorType.notFound404) {
            this.showError404 = true
          }
        }
      )
  }

  public get showWhenAccepted(): boolean {
    return this.agreement?.state == AgreementStatus.ACCEPTED
  }
}
